import { Injector, Component, OnInit, Inject } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { DOCUMENT } from '@angular/common';
import { OffcanvasOptions } from '@metronic/app/core/_base/layout/directives/offcanvas.directive';
import { AppConsts } from '@shared/AppConsts';

@Component({
    templateUrl: './default-layout.component.html',
    selector: 'default-layout',
    animations: [appModuleAnimation()]
})
export class DefaultLayoutComponent extends ThemesLayoutBaseComponent implements OnInit {

    menuCanvasOptions: OffcanvasOptions = {
        baseClass: 'kt-aside',
        overlay: true,
        closeBy: 'kt_aside_close_btn',
        toggleBy: {
            target: 'kt_aside_mobile_toggler',
            state: 'kt-header-mobile__toolbar-toggler--active'
        }
    };

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    currentLanguage: abp.localization.ILanguageInfo;
    currentLanguageName: string;
    isRightToLeft: boolean;
    
    constructor(
        injector: Injector,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(injector);
    }

    ngOnInit() {
        this.installationMode = UrlHelper.isInstallUrl(location.href);
    }
    changeByLanguage(){
        this.currentLanguage = this.localization.currentLanguage;
        // console.log("currentLanguage",this.currentLanguage);
        this.currentLanguageName = this.currentLanguage.name;
        // this.currentLanguageName = 'fa';
        // console.log("this.isRightToLeft ",this.isRightToLeft );
        if(this.currentLanguageName == "fa" || this.currentLanguageName == "ar"){
            return 'rtl'
        }else{
            return 'ltr'
        }
    }
}
